
import Vue from 'vue';
import { RunnitNode, RunnitNodeRunResult } from '@run-diffusion/shared';
import { TemplateGenerationResultsMixin, TEMPLATE_MAX_RESULTS_PER_NODE } from '@/mixins';
import RunnitResult from '@/views/Runnits/RunnitResult.vue';
import BaseButton from '@/components/base/BaseButton.vue';

export default Vue.extend({
	name: 'AssignedGenerationsSection',
	components: {
		RunnitResult,
		BaseButton,
	},
	data () {
		return {
			TEMPLATE_MAX_RESULTS_PER_NODE,
		};
	},
	props: {
		selectedNode: {
			type: Object as () => RunnitNode | null,
			required: true,
		},
		selectedResults: {
			type: Array as () => Array<{
				templateNodeId: string
				sourceNodeRunId: string
				resultUuid: string
				result: RunnitNodeRunResult
			}>,
			required: true,
		},
	},
	mixins: [TemplateGenerationResultsMixin],
	computed: {
		assignedResults (): Array<{
			templateNodeId: string
			sourceNodeRunId: string
			resultUuid: string
			result: RunnitNodeRunResult
		}> {
			if (!this.selectedNode) return [];
			return this.selectedResults.filter(r => r.templateNodeId === this.selectedNode.id);
		},
	},
	methods: {
		onUnselect (resultUuid: string) {
			if (!this.selectedNode) return;
			this.$emit('result-unselected', resultUuid, this.selectedNode.id);
		},
		onClearAll () {
			if (!this.selectedNode) return;
			this.$emit('clear-all', this.selectedNode.id);
		},
	},
});
